import { NotificationList } from "../components/NotificationList";

export const Notification = () => {
  return (
    // <Authorization
    //   permission={[
    //     {
    //       resource: ResourceCode.TemplateType,
    //       action: AuthActionVerb.READ_BULK,
    //     },
    //   ]}
    // >
    <NotificationList />
    // </Authorization>
  );
};
